export const environment = {
  production: true,
  apiBaseUrl: 'https://api.matwins.info',
};
